<div class="block">
  <span class="title d-block mb-2" role="heading" aria-level="1">{{ title }}</span>
  <span *ngIf="textContent" class="content" style="display:'inline-block'; min-height: '4em'">{{ textContent }}</span>
  <div>
    <a *ngIf="button" [routerLink]="buttonLink" class="btn btn-primary" role="button"
       title="{{ariaLabelValue}}">{{ buttonName }}</a>
  </div>
</div>
